export default "__VITE_ASSET__DvyiCwsy__"